import Immutable from 'immutable';
import { toSportType } from 'nike-ui/src/common/sports';

// TODO: checknut ci toto nepocitame 2x - druhykrat je to v scoreboardoch v cache
export function addHalfTimeToPeriodScores(match) {
    if (!match || !match.get('sportName')) {
        return match;
    }

    const sportName = toSportType(match.get('sportId'));
    if (!sportName) {
        return match;
    }

    const basketballMatchType = match.get('basketballMatchType');

    const isHalfTImeSport =
        (sportName === 'basketball' && basketballMatchType === 'DEFAULT') || sportName === 'football';

    if (!isHalfTImeSport) {
        return match;
    }

    let periodScoresState = match.get('periodScores');

    if (!periodScoresState) {
        return match;
    }

    if (
        periodScoresState.some(function(periodScore) {
            return periodScore && periodScore.getIn(['period', 'code']) === 'HT';
        })
    ) {
        return match;
    }

    const halfTime = 2;

    if (periodScoresState.size >= halfTime) {
        let scoreHome = 0;
        let scoreAway = 0;

        for (let index = 0; index < periodScoresState.size; index++) {
            const period = periodScoresState.get(index);
            if (index < halfTime) {
                scoreHome += parseInt(10, period.getIn(['score', 'home']));
                scoreAway += parseInt(10, period.getIn(['score', 'away']));
            }
        }

        periodScoresState = periodScoresState.splice(
            halfTime,
            0,
            Immutable.Map({
                period: Immutable.Map({
                    code: 'HT',
                    name: 'polcas'
                }),
                score: Immutable.Map({
                    home: scoreHome,
                    away: scoreAway
                })
            })
        );
        return match.set('periodScores', periodScoresState);
    }
    return match;
}

export function betGroups(match) {
    const working = match
        .get('bets', Immutable.Map())
        .filter(bet => bet && bet.get('id'))
        .sortBy(bet => bet.get('order'))
        .reduce(
            ([groupIds, groups], bet) => {
                let groupKey;
                if (bet.get('grouping')) {
                    groupKey = bet.get('groupKey') ? bet.get('groupKey') : bet.get('idInstancia');
                } else {
                    groupKey = bet.get('id') + '-' + bet.get('idInstancia');
                }
                return [
                    groupIds.add(groupKey),
                    groups.update(groupKey, Immutable.List(), bets =>
                        bets.push(bet).sortBy(bet => bet.get('groupOrder'))
                    )
                ];
            },
            [Immutable.OrderedSet(), Immutable.Map()]
        );
    return [
        working[0].toList(),
        working[1].map(bets => {
            const bet = bets.get(0);
            return Immutable.Map({
                betIds: bets.map(b => b.get('id')),
                name: bet.get('name'),
                idInstancia: bet.get('idInstancia'),
                instanceInfo: bet.get('instanciaInfo')
            });
        })
    ];
}
